import { createReducer } from '@reduxjs/toolkit'

import * as entityActions from '../../actions/Entities/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

import {
  IEntity,
  IEntityColumn,
  IEntityTerminology
} from 'types/GlobalEntities'
import { arrayToObject } from 'utils/functions'
import { PutSimRenamingResponse } from 'redux/api/SimRenamings'
import { TFetchStatus } from 'redux/reducers/Dashboards'

export interface IEntityReducerType {
  data: { [entityId: string]: IEntity }
  fetchStatus: TFetchStatus
}

// Initial state
const INITIAL_STATE: IEntityReducerType = {
  data: {},
  fetchStatus: 'idle'
}

// Reducer
export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(entityActions.getAll, (state) => {
      state.fetchStatus = 'fetching'
    })
    .addCase(entityActions.getAllSuccess, (state, action) => {
      state.data = arrayToObject(action.payload)
      state.fetchStatus = 'success'
    })
    .addCase(entityActions.getAllFailed, (state) => {
      state.fetchStatus = 'error'
    })
    .addCase(entityActions.putAttributesSuccess, (state, action) => {
      const { payload } = action
      const currentState = state.data[payload.entityId]

      currentState.columns = payload.data.map((column) => {
        const stateColumn = currentState.columns.find(
          (stateColumn) => stateColumn.id === column.id
        ) as IEntityColumn

        return {
          ...stateColumn,
          index: column.index,
          hidden: column.hidden
        }
      })
    })
    .addCase(entityActions.putTerminologySuccess, (state, action) => {
      const { payload } = action

      const affectedDestinations: { [key: string]: PutSimRenamingResponse } = {}

      payload.data.forEach((item) => {
        affectedDestinations[item.attribute_id] = item
      })

      const currentState = state.data[payload.entityId]

      currentState.terminology = currentState.terminology.map(
        (term): IEntityTerminology => {
          // check if column was updated
          const affected = term.definitions.findIndex(
            (def) => affectedDestinations[def.attribute_id]
          )

          if (affected === -1) {
            // no changes
            return term
          }

          return {
            ...term,
            title: {
              ...term.title,
              // update custom name
              custom:
                affectedDestinations[term.definitions[affected].attribute_id]
                  .name
            }
          }
        }
      )
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})
